import { Button, ButtonGroup, styled } from "@mui/material"

export const StyledButtonGroupSwitch = styled(ButtonGroup)(({ theme, color }) => ({
  backgroundColor: theme.palette.grey[200],
  borderRadius: "25rem!important",
  padding: "3px",
}))

export const StyledButtonSwitch = styled(Button)<{ active: boolean }>(({ theme, active }) => ({
  backgroundColor: active ? (theme.palette as any).secondary[200] : (theme.palette as any).foreground["inverted"],
  fontWeight: 400,
  border: active ? `1px solid ${theme.palette.secondary.main}` : `1px solid ${theme.palette.grey[200]}`,
  padding: "4px 12px",
  color: theme.palette.secondary.main,
  borderRadius: 0,
  position: "relative",
  marginRight: "-1px",
  zIndex: active ? 2 : 1,
  "&:first-of-type": {
    borderRadius: "25rem 0 0 25rem !important",
    borderColor: active ? (theme.palette as any).secondary.main : (theme.palette as any).grey[200],
    borderRight: active
      ? `1px solid ${theme.palette.secondary.main}`
      : `1px solid ${theme.palette.grey[200]}`,
    zIndex: active ? 2 : 1,
  },
  "&:last-of-type": {
    borderRadius: "0 25rem 25rem 0 !important",
    marginRight: 0,
    borderLeft: active
      ? `1px solid ${theme.palette.secondary.main}`
      : `1px solid ${theme.palette.grey[200]}`,
    zIndex: active ? 2 : 1,
  },
  "&:not(:first-of-type):not(:last-of-type)": {
    borderRadius: "0 !important",
    border: active
      ? `1px solid ${theme.palette.secondary.main}`
      : `1px solid ${theme.palette.grey[200]}`,
    marginRight: "-1px",
    zIndex: active ? 2 : 1,
  }
}));